import {
  Button,
  DialogContent,
  DialogTitle,
  Modal,
  ModalClose,
  ModalDialog,
  Stack,
  Typography,
} from '@mui/joy';

// Reusable Joy confirmation dialog. Replaces window.confirm across the
// admin surfaces so the confirmation UX matches the rest of the app and
// isn't at the mercy of browser-native prompt styling. Kept prop-shaped
// (title, message, confirmLabel, cancelLabel, color) rather than
// composition-shaped because every caller is doing the same three-line
// pattern; the abstraction pays back on the second use.

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmColor?: 'primary' | 'danger' | 'warning' | 'success' | 'neutral';
  loading?: boolean;
};

const ConfirmDialog = (props: Props) => {
  const {
    isOpen,
    onCancel,
    onConfirm,
    title,
    message,
    confirmLabel = 'Bevestigen',
    cancelLabel = 'Annuleren',
    confirmColor = 'primary',
    loading = false,
  } = props;

  return (
    <Modal open={isOpen} onClose={onCancel}>
      <ModalDialog size="md" sx={{ minWidth: 420 }}>
        <ModalClose />
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ marginTop: 2 }}>
            <Typography level="body-sm">{message}</Typography>
            <Stack direction="row" spacing={1}>
              <Button
                fullWidth
                color={confirmColor}
                onClick={onConfirm}
                loading={loading}
              >
                {confirmLabel}
              </Button>
              <Button
                fullWidth
                color="neutral"
                variant="soft"
                onClick={onCancel}
                disabled={loading}
              >
                {cancelLabel}
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};

export default ConfirmDialog;
